<template>
  <a :href="src" v-if="isMobile" class="com-link-img">
    <img src="@/assets/images/macbook_click.png" class="click" alt="">
    <img :src="imgSrc" class="computer-img">
  </a>
  <div class="computer" :style="{height: height}" ref="computer" v-else>
    <img src="http://video.cgaii.com/new4dage/images/images/macbook_1.png">
    <img src="http://video.cgaii.com/new4dage/images/images/macbook_2.png">
    <img src="http://video.cgaii.com/new4dage/images/images/macbook_3.png">
    <img src="http://video.cgaii.com/new4dage/images/images/macbook_4.png">
    <img src="http://video.cgaii.com/new4dage/images/images/macbook_5.png">
    <iframe :src="this.src" />
  </div>
</template>

<script>
import browser from '@/util/browser'

export default {
  props: ['src', 'imgSrc'],
  data () {
    return {
      height: 0,
      isMobile: browser.mobile
    }
  },
  mounted () {
    if (!this.isMobile) {
      this.onResize = () => {
        this.height = this.$refs.computer.offsetWidth * 0.5408 + 'px'
      }
      window.addEventListener('resize', this.onResize)
      setTimeout(this.onResize)
    }
  },
  destroyed () {
    this.isMobile || window.removeEventListener('resize', this.onResize)
  }
}
</script>

<style scoped>
.com-link-img {
  position: relative;
  display: block;
}
.click {
  position: absolute;
  bottom: 42%;
  right: 32%;
  width: 50px;
  animation: clickAnimation 2s infinite alternate
}

@keyframes clickAnimation {
  from {
    transform: translateX(-20px)  translateY(-10px) scale(.9)
  }

  to {
    transform: translateX(20px) translateY(10px) scale(1)
  }
}

.computer-img {
  width: 100%;
  height: auto;
}
.computer {
  margin: 0 auto;
  max-width: 1210px;
  width: 100%;
  position: relative;
}

.computer img {
  position: absolute;
  z-index: 2;
}

.computer img:nth-child(1) {
  height: 86.11%;
  top: 0;
  left: 15.41%;
  width: 2.8245%;
}

.computer img:nth-child(2) {
  height: 6%;
  top: 0;
  width: 63.70%;
  left: 18.2345%;
}

.computer img:nth-child(3) {
  height: 86.11%;
  top: 0;
  left: 81.9345%;
}

.computer img:nth-child(4) {
  width: 63.70%;
  height: 6%;
  top: 79.90%;
  left: 18.2345%;
}

.computer img:nth-child(5) {
  height: 13.77%;
  bottom: 0.2%;
  width: auto;
  left: -7.55%;
}

.computer iframe {
  position: absolute;
  z-index: 1;
  left: 17.3%;
  top: 5.9%;
  width: 65.4%;
  height: 74.6%;
}
</style>



// WEBPACK FOOTER //
// src/components/computer/index.vue